
<template>
  <div class="container">
    <div class="row" v-for="objectGroup in objectGroups" :key="objectGroup.id">
      <div class="col-md-12">
        <ObjectDescriptionListByGroup :objectGroupId="objectGroup.id" :objectGroupName="objectGroup.name"/>
      </div>
      <ObjectDescriptionCreate :objectGroupId="objectGroup.id"/>
    </div>
    <div class="row">
      <div class="col-md-12">
        <ObjectGroupCreate/>
      </div>
    </div>
  </div>
</template>

<script>

import ObjectDescriptionListByGroup from './ObjectDescriptionListByGroup'
import ObjectDescriptionCreate from './ObjectDescriptionCreate'
import ObjectGroupCreate from './ObjectGroupCreate'

export default {
  components: {
    ObjectDescriptionListByGroup,
    ObjectDescriptionCreate,
    ObjectGroupCreate
  },
  name: 'ObjectManagement',
  data () {
    return {
      objectGroups: []
    }
  },
  mounted () {
    this.$http
      .get('/api/objectgroups')
      .then(response => { this.objectGroups = response.data })
      .catch(error => console.log(error))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ObjectManagement/ObjectManagement.vue